import { NgModule } from "@angular/core";
import { DashboardRoutingModule } from "./dashboard-routing.module";
import { ConversionMetricsSkeletonComponent } from "./features/conversion-metrics/components/conversion-metrics-skeleton/conversion-metrics-skeleton.component";
import { ConversionRateCardComponent } from "./features/conversion-metrics/components/conversion-rate-card/conversion-rate-card.component";
import { ConversionMetricsComponent } from "./features/conversion-metrics/conversion-metrics.component";
import { DashboardWidgetComponent } from './features/home/components/dashboard-widget/dashboard-widget.component';
import { FundedHeroCardComponent } from "./features/home/components/funded-hero-card/funded-hero-card.component";
import { InactivityPanelComponent } from "./features/home/components/inactivity-panel/inactivity-panel.component";
import { RequiringActionListComponent } from "./features/home/components/requiring-action-list/requiring-action-list.component";
import { SnapshotErrorCardComponent } from "./features/home/components/snapshot-error-card/snapshot-error-card.component";
import { SnapshotSkeletonComponent } from "./features/home/components/snapshot-skeleton/snapshot-skeleton.component";
import { SnapshotTilesComponent } from "./features/home/components/snapshot-tiles/snapshot-tiles.component";
import { HomeComponent } from "./features/home/home.component";
import { PartnerScorecardSkeletonComponent } from "./features/partner-scorecard/components/partner-scorecard-skeleton/partner-scorecard-skeleton.component";
import { ScorecardBarChartComponent } from "./features/partner-scorecard/components/scorecard-bar-chart/scorecard-bar-chart.component";
import { PartnerScorecardComponent } from "./features/partner-scorecard/partner-scorecard.component";
import { PipelineFunnelBarComponent } from "./features/pipeline-health/components/pipeline-funnel-bar/pipeline-funnel-bar.component";
import { PipelineFunnelCardComponent } from "./features/pipeline-health/components/pipeline-funnel-card/pipeline-funnel-card.component";
import { PipelineHealthSkeletonComponent } from "./features/pipeline-health/components/pipeline-health-skeleton/pipeline-health-skeleton.component";
import { PipelineMetricCardComponent } from "./features/pipeline-health/components/pipeline-metric-card/pipeline-metric-card.component";
import { PipelineHealthComponent } from "./features/pipeline-health/pipeline-health.component";
import { InsightRowComponent } from "./features/smart-insights/components/insight-row/insight-row.component";
import { SmartInsightsSkeletonComponent } from "./features/smart-insights/components/smart-insights-skeleton/smart-insights-skeleton.component";
import { SmartInsightsComponent } from "./features/smart-insights/smart-insights.component";
import { TrendMetricsSkeletonComponent } from "./features/trend-metrics/components/trend-metrics-skeleton/trend-metrics-skeleton.component";
import { TrendTileComponent } from "./features/trend-metrics/components/trend-tile/trend-tile.component";
import { TrendVolumeChartComponent } from "./features/trend-metrics/components/trend-volume-chart/trend-volume-chart.component";
import { TrendMetricsComponent } from "./features/trend-metrics/trend-metrics.component";
import { CompactCurrencyPipe } from "./shared/compact-currency.pipe";
import { DashboardBreadcrumbComponent } from "./shared/dashboard-breadcrumb/dashboard-breadcrumb.component";
import { DashboardCustomDateDialogComponent } from "./shared/dashboard-custom-date-dialog/dashboard-custom-date-dialog.component";
import { DashboardFilterBarComponent } from "./shared/dashboard-filter-bar/dashboard-filter-bar.component";
import { DashboardPageShellComponent } from "./shared/dashboard-page-shell/dashboard-page-shell.component";
import { SharedModule } from "../../shared/shared.module";

@NgModule({
  imports: [SharedModule, DashboardRoutingModule],
  declarations: [
    HomeComponent,
    DashboardWidgetComponent,
    DashboardPageShellComponent,
    DashboardFilterBarComponent,
    DashboardBreadcrumbComponent,
    DashboardCustomDateDialogComponent,
    PipelineHealthComponent,
    PipelineMetricCardComponent,
    PipelineFunnelBarComponent,
    PipelineFunnelCardComponent,
    PipelineHealthSkeletonComponent,
    ConversionMetricsComponent,
    ConversionMetricsSkeletonComponent,
    ConversionRateCardComponent,
    TrendMetricsComponent,
    TrendMetricsSkeletonComponent,
    TrendTileComponent,
    TrendVolumeChartComponent,
    SmartInsightsComponent,
    SmartInsightsSkeletonComponent,
    InsightRowComponent,
    PartnerScorecardComponent,
    PartnerScorecardSkeletonComponent,
    ScorecardBarChartComponent,
    FundedHeroCardComponent,
    SnapshotTilesComponent,
    RequiringActionListComponent,
    InactivityPanelComponent,
    SnapshotErrorCardComponent,
    SnapshotSkeletonComponent,
    CompactCurrencyPipe,
  ]
})
export class DashboardModule { }
